import { create } from 'zustand';

interface SessionCounts {
  alerts: number;
  violations: number;
}

interface AiSessionRealtimeState {
  counts: Record<string, SessionCounts>;
  registerAlerts: (sessionId: string, delta: number) => void;
  registerViolations: (sessionId: string, delta: number) => void;
  clear: (sessionId: string, kind: 'alerts' | 'violations') => void;
}

const EMPTY: SessionCounts = { alerts: 0, violations: 0 };

// Tracks alerts/violations that have attached to an AI session since its
// detail page was last fetched, keyed by session id. AiSessionDetailPage
// reads this to show a blinking "+N" on whichever tab (Alerts/Violations)
// the user isn't currently viewing when a new item arrives over the
// realtime socket — mirrors the cross-tab badge on the Threats page.
export const useAiSessionRealtimeStore = create<AiSessionRealtimeState>()((set) => ({
  counts: {},

  registerAlerts: (sessionId, delta) =>
    set((state) => {
      if (delta <= 0) return state;
      const prev = state.counts[sessionId] ?? EMPTY;
      return { counts: { ...state.counts, [sessionId]: { ...prev, alerts: prev.alerts + delta } } };
    }),

  registerViolations: (sessionId, delta) =>
    set((state) => {
      if (delta <= 0) return state;
      const prev = state.counts[sessionId] ?? EMPTY;
      return { counts: { ...state.counts, [sessionId]: { ...prev, violations: prev.violations + delta } } };
    }),

  clear: (sessionId, kind) =>
    set((state) => {
      const prev = state.counts[sessionId] ?? EMPTY;
      if (prev[kind] === 0) return state;
      return { counts: { ...state.counts, [sessionId]: { ...prev, [kind]: 0 } } };
    }),
}));
